import { Fragment, VFC, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  TableHead,
  Typography,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DeviceDetailResponse } from "../../terminal/api/TerminalForm";
import { Utility } from "../../../utils/Utility";
import { DeviceUiConverter } from "../../../converter/DeviceUiConverter";
import SimTypeBox from "../box/SimTypeBox";
import DeviceDetailInfoGrid from "../detailparts/device/DeviceDetailInfoGrid";

const lableColor = "#545b64";
const contentColor = "#16191f";
const contentFontSize = "0.875rem";

const style = {
  gridWrap: {
    fontSize: contentFontSize,
    mb: 2,
    "& > div": {
      p: 1,
    },
    "& > div:nth-of-type(3n+2)": {
      borderRight: "1px solid #eaeded",
      borderLeft: "1px solid #eaeded",
    },
    "& div div:nth-of-type(1)": {
      color: lableColor,
    },
    "& div div:nth-of-type(2)": {
      color: contentColor,
      fontWeight: "bold",
    },
  },
};

type Props = {
  device: DeviceDetailResponse;
};
const DeviceDetailView: VFC<Props> = ({ device }) => {
  return (
    <Box sx={{ p: 3, border: 0 }}>
      <Box display={"flex"} flexWrap={"wrap"} sx={style.gridWrap}>
        <DeviceDetailInfoGrid
          contentColor={contentColor}
          contentFontSize={contentFontSize}
          device={device}
        />
      </Box>
    </Box>
  );
};

export default DeviceDetailView;
